// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/HomePage.css */

.home-page {
  padding: 32px clamp(16px, 4vw, 48px) 64px;
}

.genre-section {
  position: relative;
  margin-bottom: 36px;
}

.genre-section h1 {
  color: var(--text);
  font-size: 21px;
  font-weight: 600;
  margin: 0 0 4px 4px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.genre-section h1::before {
  content: '';
  width: 4px;
  height: 18px;
  border-radius: var(--radius-full);
  background: linear-gradient(180deg, var(--accent-start), var(--accent-end));
}

.movie-grid-wrapper {
  position: relative;
  overflow: hidden;
}

.movie-grid {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 16px 4px 8px;
  gap: 4px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* legacy Edge/IE */
}

.movie-grid::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
  width: 0;
  height: 0;
}

.movie-grid.wrap {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  overflow: visible;
  gap: 24px 14px;
  padding: 16px 4px 8px;
}

.movie-grid.wrap .movie-card {
  width: 100%;
  margin: 0;
}

@media (max-width: 1200px) {
  .movie-grid.wrap {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (max-width: 720px) {
  .movie-grid.wrap {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 480px) {
  .movie-grid.wrap {
    grid-template-columns: repeat(2, 1fr);
  }
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(9, 11, 18, 0.7);
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  border: 1px solid var(--border);
  color: var(--text);
  font-size: 16px;
  cursor: pointer;
  z-index: 10;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity var(--fast) var(--ease), background var(--fast) var(--ease), border-color var(--fast) var(--ease);
}

.movie-grid-wrapper:hover .arrow {
  opacity: 1;
}

.arrow:hover {
  background: var(--accent);
  border-color: var(--accent);
  color: #1a0e05;
}

.arrow-left {
  left: 4px;
}

.arrow-right {
  right: 4px;
}

.page-loading {
  min-height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  font-size: 15px;
  letter-spacing: 0.02em;
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,2EAA2E;AAC7E;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,QAAQ;EACR,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,mBAAmB;AAC/C;;AAEA;EACE,aAAa,EAAE,uBAAuB;EACtC,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,gCAAgC;EAChC,kCAA0B;UAA1B,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,qHAAqH;AACvH;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB","sourcesContent":["/* src/pages/HomePage.css */\n\n.home-page {\n  padding: 32px clamp(16px, 4vw, 48px) 64px;\n}\n\n.genre-section {\n  position: relative;\n  margin-bottom: 36px;\n}\n\n.genre-section h1 {\n  color: var(--text);\n  font-size: 21px;\n  font-weight: 600;\n  margin: 0 0 4px 4px;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.genre-section h1::before {\n  content: '';\n  width: 4px;\n  height: 18px;\n  border-radius: var(--radius-full);\n  background: linear-gradient(180deg, var(--accent-start), var(--accent-end));\n}\n\n.movie-grid-wrapper {\n  position: relative;\n  overflow: hidden;\n}\n\n.movie-grid {\n  display: flex;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  padding: 16px 4px 8px;\n  gap: 4px;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* legacy Edge/IE */\n}\n\n.movie-grid::-webkit-scrollbar {\n  display: none; /* Chrome/Safari/Edge */\n  width: 0;\n  height: 0;\n}\n\n.movie-grid.wrap {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  overflow: visible;\n  gap: 24px 14px;\n  padding: 16px 4px 8px;\n}\n\n.movie-grid.wrap .movie-card {\n  width: 100%;\n  margin: 0;\n}\n\n@media (max-width: 1200px) {\n  .movie-grid.wrap {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n@media (max-width: 720px) {\n  .movie-grid.wrap {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 480px) {\n  .movie-grid.wrap {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(9, 11, 18, 0.7);\n  backdrop-filter: blur(6px);\n  border: 1px solid var(--border);\n  color: var(--text);\n  font-size: 16px;\n  cursor: pointer;\n  z-index: 10;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity var(--fast) var(--ease), background var(--fast) var(--ease), border-color var(--fast) var(--ease);\n}\n\n.movie-grid-wrapper:hover .arrow {\n  opacity: 1;\n}\n\n.arrow:hover {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: #1a0e05;\n}\n\n.arrow-left {\n  left: 4px;\n}\n\n.arrow-right {\n  right: 4px;\n}\n\n.page-loading {\n  min-height: 40vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  font-size: 15px;\n  letter-spacing: 0.02em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
